import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../../../redux-store";
import { notify } from "../../../../ducks/notifications";

/**
 * Empty (0-byte) files are refused before upload: they have nothing to show,
 * and the preview worker can't render them (DORA-478).
 *
 * Returns a function that keeps the non-empty files and tells the user which
 * ones were left out.
 */
const useDropEmptyFiles = () => {
  const { t } = useTranslation("shipmentModal");
  const dispatch = useAppDispatch();

  return (files: File[]): File[] => {
    const emptyFiles = files.filter((file) => file.size === 0);
    if (emptyFiles.length) {
      dispatch(
        notify({
          message: t("cards.documents.notificationErrorEmptyFile", {
            count: emptyFiles.length,
            fileNames: emptyFiles.map((file) => file.name).join(", "),
          }),
          type: "error",
        })
      );
    }
    return files.filter((file) => file.size > 0);
  };
};

export default useDropEmptyFiles;
